// extracted by mini-css-extract-plugin
export default {"container":"emojiBox_container__bLZdj","emojiContainer":"emojiBox_emojiContainer__Njzlt","selectedEmoji":"emojiBox_selectedEmoji__YTa2+"};